<div class="divgrups" id="divPrincipalenccotiza">
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-7" style="margin-top: -5px; margin-bottom: -13px">
                    <div class="p-grid">
                        <div class="p-col-12" style="margin-top: 10px;">
                            <div class="p-grid">
                                <div class="p-col-2">
                                    <span>Artículo:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" id="ART_CODIGO" (keydown.enter)="cambiarFoco($event)"
                                    maxlength="25" [disabled]="booleanall"
                                        (input)="cambio($event)" [(ngModel)]="encabezado.ART_CODIGO" pInputText
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                    [disabled]="booleanall"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="abrirarticulo(encabezado.ART_CODIGO)"></button>
                                </div>
                                <div class="p-col-2">
                                    <!-- <span style="width: 100%;">{{encabezado.ART_NOMBRE}}</span> -->
                                    <input type="text" id="ART_NOMBRE" (keydown.enter)="cambiarFoco($event)"
                                    maxlength="100"
                                    [disabled]="booleanall"
                                        (input)="cambio($event)" [(ngModel)]="encabezado.ART_NOMBRE" pInputText
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-2">
                                    <div class="p-grid">
                                        <div class="p-col-5">
                                            <span>Tiro:</span>
                                        </div>
                                        <div class="p-col-7">
                                            <input type="text" id="ENCCOTIZA_TIRO" (keydown.enter)="cambiarFoco($event)"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (input)="cambio($event)" [(ngModel)]="encabezado.ENCCOTIZA_TIRO"
                                                [disabled]="booleanall"
                                                pInputText style="width: 100%" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-2">
                                    <div class="p-grid">
                                        <div class="p-col-3">
                                            <span>Retiro:</span>
                                        </div>
                                        <div class="p-col-9">
                                            <input type="text" id="ENCCOTIZA_RETIRO"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [disabled]="booleanall"
                                                [(ngModel)]="encabezado.ENCCOTIZA_RETIRO" pInputText style="width: 100%"
                                                autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-2">
                                    <span>Cantidad:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" id="ENCCOTIZA_CANTIDAD" (keydown.enter)="cambiarFoco($event)"
                                        oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');
                                    " (input)="cambio($event)" [(ngModel)]="encabezado.ENCCOTIZA_CANTIDAD" pInputText
                                    [disabled]="booleanall"
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-3"></div>
                                <div class="p-col-2">
                                    <div class="p-grid">
                                        <div class="p-col-5">
                                            <span># Placas:</span>
                                        </div>
                                        <div class="p-col-7">
                                            <input type="text" id="ENCCOTIZA_NUMPLACAS"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [(ngModel)]="encabezado.ENCCOTIZA_NUMPLACAS" pInputText
                                                [disabled]="booleanall"
                                                style="width: 100%" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-2">
                                    <span>Fórmula:</span>
                                </div>
                                <div class="p-col-1">
                                    <!-- <p-dropdown [options]="cmbProceso" [style]="{'minWidth': '100%', 'width':'100%'}"
                                        optionLabel="name" [panelStyle]="{'width':'110%'}" [(ngModel)]="selectProceso"
                                        (onChange)="changeProceso()"></p-dropdown> -->

                                    <p-dropdown id="formula" [style]="{'width': '200px'}"
                                        [panelStyle]="{'width':'300px'}" inputId="ENCCOTIZA_FORMULA"
                                        [(ngModel)]="encabezado.ENCCOTIZA_FORMULA" 
                                        [options]="cmbProceso"
                                        maxlength="10"
                                        (ngModelChange)="cambio($event)" 
                                        (keydown.enter)="cambiarFoco($event)"
                                        [disabled]="booleanall"
                                        editable="true">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-4"></div>
                                <div class="p-col-4">
                                    <div class="p-grid">
                                        <div class="p-col-7">
                                            <span>Maculatura:</span>
                                        </div>
                                        <div class="p-col-5">
                                            <input type="text" id="ENCCOTIZA_MACULATURA"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [(ngModel)]="encabezado.ENCCOTIZA_MACULATURA" pInputText
                                                [disabled]="booleanall"
                                                style="width: 100%" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-2">
                                    <span>BodegaPT:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" id="ENCCOTIZA_BODPT" (keydown.enter)="cambiarFoco($event)"
                                        (input)="cambio($event)" [(ngModel)]="encabezado.ENCCOTIZA_BODPT" pInputText
                                        [disabled]="booleanall"
                                        maxlength="10"
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        [disabled]="booleanall"
                                        (click)="abrirbodega(encabezado.ENCCOTIZA_BODPT,'pt')"></button>
                                </div>
                                <div class="p-col-2">
                                    <span style="width: 100%;">{{encabezado.BODPT_NOMBRE}}</span>
                                </div>

                                <div class="p-col-4">
                                    <div class="p-grid">
                                        <div class="p-col-7">
                                            <span>Total Real a Producir:</span>
                                        </div>
                                        <div class="p-col-5">
                                            <input type="text" id="ENCCOTIZA_TOTREALPRO"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [(ngModel)]="encabezado.ENCCOTIZA_TOTREALPRO" pInputText disabled
                                                style="width: 100%" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px; margin-bottom: -13px">
                            <div class="p-grid">
                                <div class="p-col-2">
                                    <span>BodegaMP:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" id="ENCCOTIZA_BODMP" (keydown.enter)="cambiarFoco($event)"
                                        (input)="cambio($event)" [(ngModel)]="encabezado.ENCCOTIZA_BODMP" pInputText
                                        [disabled]="booleanall"
                                        maxlength="10"
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                    [disabled]="booleanall"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="abrirbodega(encabezado.ENCCOTIZA_BODMP,'mp')"></button>
                                </div>
                                <div class="p-col-2">
                                    <span style="width: 100%;">{{encabezado.BODMP_NOMBRE}}</span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <!-- Segunda columna -->
                <div class="p-col-5" style="margin-top: -5px; margin-bottom: -13px">
                    <div class="p-grid">
                        <div class="p-col-12" style="margin-top: 10px">
                            <div class="p-grid">
                                <div class="p-col-3">
                                    <div class="p-grid">
                                        <div class="p-col-7">
                                            <span>Tamaño de corte</span>
                                        </div>
                                        <div class="p-col-5">
                                            <input type="text" id="ENCCOTIZA_ANCHO"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [disabled]="booleanall"
                                                [(ngModel)]="encabezado.ENCCOTIZA_ANCHO" pInputText style="width: 100%"
                                                autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-3">
                                            <span>X</span>
                                        </div>
                                        <div class="p-col-9">
                                            <input type="text" id="ENCCOTIZA_LARGO"
                                                oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                                (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                                [disabled]="booleanall"
                                                [(ngModel)]="encabezado.ENCCOTIZA_LARGO" pInputText style="width: 100%"
                                                autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-1"></div>
                                <!-- <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/guardar.webp);"
                                        [disabled]="booleanall"
                                        (click)="guardarcot(encabezado.ENCCOTIZA_NUMERO)"></button>
                                </div> -->
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-3"></div>
                                <div class="p-col-1">
                                    <span style="width: 100%;">{{encabezado.ENCCOTIZA_ANCHO}}</span>
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/077-delete.webp);"
                                        [disabled]="booleanall"
                                        (click)="anularcot(encabezado.ENCCOTIZA_NUMERO)"></button>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -5px; margin-bottom: -15px">
                            <div class="p-grid">
                                <div class="p-col-11">
                                    <div class="p-grid">
                                        <div class="p-col-5">
                                            <textarea style="z-index: 1; width: 230px; height: 53px;" id="vistaprevia"
                                                type="text" pInputTextarea disabled [(ngModel)]="grafico"
                                                autocomplete="off"></textarea>
                                        </div>
                                        <div class="p-col-1">
                                            <span style="width: 100%;">{{encabezado.ENCCOTIZA_LARGO}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -5px; margin-bottom: -15px">
                            <div class="p-grid">
                               
                            </div>
                           
                        </div>
                        <div class="p-col-12" style="margin-top: -5px; margin-bottom: -13px">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-aggridsacicot [width]="1300" [height]="430" [enableSorting]="false" [enableFilter]="true"
    [rowData]="encabezado.detalle" [frameworkComponents]="frameworkComponents" [animateRows]="true"
    [rowSelection]="rowSelection" [columnDefs]="columnDefsDetcotiza" [defaultColDef]="defaultColDef"
    [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true" [botonNuevo]='bolNuevodet'
    (selected)="selecciondetfac($event)" (rdbtipodet)="rdbtipodet($event)" [comboOpciones]="comboOpciones"
    [tipodetalle]="tipodetalle" (cambios)="cambio($event)"></app-aggridsacicot>
<div class="divgrupstabla">
    <div class="p-grid">
        <!-- <span style="font-weight: bold; text-align: left">Totales</span> -->
        <div class="p-col-12" style="margin-top: -10px;">
            <div class="p-grid">
                <div class="p-col-1">
                    <span class="obligatorio">Total Costo</span>
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <span class="obligatorio">% Util.</span>
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <span class="obligatorio">Utilidad</span>
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <span class="obligatorio">Precio Uni.</span>
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <span class="obligatorio">Precio Total</span>
                </div>
                <div class="p-col-1"></div>
                <!-- <div class="p-col-1">
                                    <span
                                        *ngIf="encabezado.TRNCOBRO_TIPODOC !== 'DAN'"
                                        class="obligatorio">A Cobrar</span>
                                    <span
                                        *ngIf="encabezado.TRNCOBRO_TIPODOC === 'DAN'"
                                        class="obligatorio">A Pagar</span>
                                </div> -->
                <div class="p-col-1"></div>
            </div>
        </div>
        <div class="p-col-12" style="margin-top: -15px; margin-bottom: -15px">
            <div class="p-grid">
                <div class="p-col-1">
                    <input type="text" class="totales" pInputText [(ngModel)]="encabezado.ENCCOTIZA_TOTCOSTO"
                        [disabled]="true" autocomplete="off">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <input type="text" class="totales" pInputText [(ngModel)]="encabezado.ENCCOTIZA_PORCEUTIL"
                    (keydown.enter)="venenccotizacionService.calculartotal(encabezado.ENCCOTIZA_NUMERO)"
                    oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');
                                    "
                        [disabled]="booleanall" autocomplete="off">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <input type="text" class="totales" pInputText [(ngModel)]="encabezado.ENCCOTIZA_UTILIDAD"
                        [disabled]="true" autocomplete="off">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <input type="text" class="totales" pInputText [(ngModel)]="encabezado.ENCCOTIZA_PRECIOUNI"
                        [disabled]="true" autocomplete="off">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <input type="text" class="totales" pInputText [(ngModel)]="encabezado.ENCCOTIZA_PRECIOTOT"
                        [disabled]="true" autocomplete="off">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-1">
                    <!-- <input type="text" class="totales" pInputText
                                        [(ngModel)]="encabezado.TOTALACOBRAR"
                                        [disabled]="true" autocomplete="off"> -->
                </div>
                <div class="p-col-1"></div>
            </div>
        </div>
    </div>
</div>
<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
        [consulta]="consulta" [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)">
    </app-busquedadlg>
</p-dialog>